export class ChainsFunction extends Function {
}
const global = {};
export default global;
